import {AppsyncService} from './AppsyncService'
import gql from "graphql-tag";

import { findWorkFlows, listExceptions, listEquipmentVehicles } from "../graphql/queries";
import {oktaAuth} from "../config/OktaConfig";

import getDeclarantsMock from "../mocks/getDeclarants.mock.json";
import getImportersOfRecordMock from "../mocks/getImportersOfRecord.mock.json";
import getBondsMock from "../mocks/getBonds.mock.json";
import getExceptionsMock from "../mocks/getExceptions.mock.json";

import { BondsResponse, DeclarantsResponse, ImportersResponse } from './Types';
import { SortingState } from '@tanstack/table-core';

export default class GraphQLService {

    appsyncService : AppsyncService;

    constructor() {
        this.appsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_FLOW_OVERVIEW_ENDPOINT!, oktaAuth)
        //TODO: below line is for local dev
        // this.appsyncService = new AppsyncService('/graphql', oktaAuth)
    }

        async findWorkFlows(): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(findWorkFlows),
                fetchPolicy: 'network-only',
                variables: {

                }
            }
        );
    }

    async getDeclarants(): Promise<DeclarantsResponse> {
        // return a promise with a mock response
        return Promise.resolve(getDeclarantsMock);
    }

    async getImportersOfRecord(): Promise<ImportersResponse> {
        // return a promise with a mock response
        return Promise.resolve(getImportersOfRecordMock);
    }

    async getBonds(): Promise<BondsResponse> {
        // return a promise with a mock response
        return Promise.resolve(getBondsMock);
    }

    async getExceptions(sorting: SortingState, globalSearch: string, currentGeos: string[]): Promise<any> {
        // return a promise with a mock response
        console.log("getExceptions called with sorting", sorting.toString(), "globalSearch", globalSearch, "currentGeos", currentGeos);
        return Promise.resolve(getExceptionsMock);
        const variables = {
            limit: 25,
            offset: 0,
            filter: {},
            orderBy: mapSortingStateToOrderBy(sorting),
            customsTerritories: ["US", "EU"]
       };
        console.log("getting exceptions with sorting", sorting.toString());

        return this.appsyncService.appSyncClient.query({
            query: gql(listExceptions),
            fetchPolicy: 'network-only',
            variables
        });
    }

    async getEquipmentVehicles(): Promise<any> {
        // return a promise with a mock response
        return this.appsyncService.appSyncClient.query({
            query: gql(listEquipmentVehicles),
            fetchPolicy: 'network-only',
            variables: {

            }
        });
    }

}

function mapSortingStateToOrderBy(sorting: SortingState): { field: string; direction: string } | undefined {
  if (!sorting.length) return undefined;
  const sort = sorting[0];
  return {
    field: sort.id.toUpperCase(), // or map to your GraphQL field name if needed
    direction: sort.desc ? 'DESC' : 'ASC'
  };
}

